import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  GET_FAQ,
  GET_ABOUT_US,
  GET_CONTACT_US,
  SEND_MAIL,
  GET_RESOURCE_BY_TYPE,
  GET_PRICING,
  GET_ATHLETE_PRICING,
  GET_PREMIUM_CLUB_HEAD_COACH_PRICING,
  GET_PRICING_DETAIL,
  GET_PRICING_PICTURES,
  GET_PRIVACY_POLICY,
  GET_TERMS_AND_CONDITIONS
} from "@/utils/api-url";

export default class misc extends Base {
  constructor(params = {}) {
    super(params);
  }

  static resourceName() {
    return "misc";
  }

  static getAboutUs() {
    return apiDispatcher(GET_ABOUT_US());
  }

  static getFaq(params) {
    return apiDispatcher(GET_FAQ(params));
  }

  static getContactUs() {
    return apiDispatcher(GET_CONTACT_US());
  }

  static sendMail(params) {
    return apiDispatcher(SEND_MAIL(params));
  }

  static getResourceByType(params) {
    return apiDispatcher(GET_RESOURCE_BY_TYPE(params));
  }

  static getPricing() {
    return apiDispatcher(GET_PRICING());
  }

  static getAthletePricing(params) {
    return apiDispatcher(GET_ATHLETE_PRICING(params));
  }

  static getpremiumclubHeadCoachPricing(params) {
    return apiDispatcher(GET_PREMIUM_CLUB_HEAD_COACH_PRICING(params));
  }

  static getPricingDetail(params) {
    return apiDispatcher(GET_PRICING_DETAIL(params));
  }

  static getPricingPictures(params) {
    return apiDispatcher(GET_PRICING_PICTURES(params));
  }

  static getPrivacyPolicy() {
    return apiDispatcher(GET_PRIVACY_POLICY());
  }

  static getTermsAndConditions() {
    return apiDispatcher(GET_TERMS_AND_CONDITIONS());
  }
}
